import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { post } from '../../modules/utility';
import DeliveryTicket from './DeliveryTicket';

class DeliveryTicketFromMove extends Component {
	constructor(props) {
		super(props);
		const geoTabName = _.get(this.props, ['match', 'params', 'geoTabName']);
		const moveNumber = _.get(this.props, ['match', 'params', 'moveNumber']);
		const accessToken = _.get(this.props, ['match', 'params', 'accessToken']);

		if (!geoTabName) {
			alert('Missing geoTabName');
		}

		if (!moveNumber) {
			alert('Missing moveNumber');
		}

		this.state = {
			geoTabName,
			moveNumber,
			accessToken,
			errors: [],
			isSearching: false,
		};
	}

	componentDidMount() {
		//- Only used for updates
		const { geoTabName, moveNumber, accessToken } = this.state;

		this.setState({ isSearching: true });
		const params = {
			geoTabName,
			moveNumber,
		};

		if (accessToken) {
			params.accessToken = accessToken;
		}

		post({
			method: 'tmw.getDeliveryTicket',
			params,
			callback: (err, r) => {
				if (err) {
					return this.setState({
						isSearching: false,
						searchError: err,
					});
				}

				this.setState({
					isSearching: false,
					deliveryTicket: r.deliveryTicket,
				});
			},
		});
	}

	render() {
		const { deliveryTicket } = this.state;

		if (!deliveryTicket) {
			return <div>Fetching delivery ticket...</div>;
		}
		return <DeliveryTicket deliveryTicket={deliveryTicket} />;
	}
}

DeliveryTicketFromMove.propTypes = {
	classes: PropTypes.object.isRequired,
	deliveryTicket: PropTypes.object.isRequired,
};

export default DeliveryTicketFromMove;
